import React, { useEffect, useRef, useState } from "react";
import "../mycartcomponent/Mycart.css";
import { ApiCall, Web_url } from "../../common/Const";
import store from "../../redux/Store";
import $ from 'jquery';
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

function RemoveCartModule(value) {
  const [activeValue, setActiveValue] = useState({});
  const [buttonDisabled,setButtonDisabled] =useState(false);
  const [fav, setFav] = useState([]);
  
  useEffect(()=>{
    console.log(value.value,"value")
    setActiveValue(value.value);
  },[value])
  useEffect(()=>{
    favlist();
  },[])
  useEffect(()=>{
    console.log("HAI",fav.length,activeValue.product_id)
    if(fav.length != 0 && activeValue.product_id){
      let list = fav.find((res) => {
        if (activeValue.product_id == res.product_id) {
          return true;
        } else {
          return false;
        }
      });
      console.log(list);
      if(list != undefined){
        setButtonDisabled(true);
      }else{
        setButtonDisabled(false);
      }

    }
  },[fav,value,activeValue])
  const user = useSelector((state) => state.auth.user);
    const remove =() =>{
        store.dispatch({
          type: "removeFromCart",
          payload: activeValue,
        });
        $("#close_btn").click();
    }
    const wishlist =() =>{
      const favParams = { customer_id: user && user.id > 0 && user.id, product_id:  activeValue.product_id};
        ApiCall("addFav", favParams)
        .then((data) => {
          // console.log(data);
          if (data.message == "Success") {
            console.log("res Fav",data);
            toast.success("Item added in favourite list successfully.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            store.dispatch({
              type: "removeFromCart",
              payload: activeValue,
            });
            $("#close_btn").click();
          }else{
            toast.error("Must be login first.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((err) => console.log(err));
    }
    const favlist = () => {
      ApiCall('favView', {
          customer_id: user && user.id > 0 && user.id,
          page_number: 0
      }).then((data) => {
        console.log(data,"data")
          if (data.message === "Success.") {
              setFav(data.result);
          }
          else {
              setFav([]);
          }
      }).catch(err => console.log(err));
  }
  return (
    <div>
    <ToastContainer />
      <div
        class="modal fade"
        id="removeCart"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div
              class="modal-body mdl-body"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
            <button
              type="button"
              class="btn-close cbutton"
              id="close_btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{position: "absolute",right: "10px"}}
            ></button>
              <div class="mobile-popup">
                <div class="col-3 imgpopup">
                  <img
                    class="popupOfferlist_image"
                    src={activeValue.product_image ? Web_url.Domain_url + activeValue.product_image[0].url :null}
                    alt="Be Minimalist Gold Rings"
                    style={{ height: "100%", width: "100%" }}
                  />
                </div>
                <div class="col-6 textpopup">
                  <h2 class="headertextpopup">Remove from bag</h2>
                  <p class="paratextpopup">
                    Are you sure that you want to remove this item from bag ?
                  </p>
                </div>
              </div>
            </div>
            <div className="breakpoint"></div>
            <div class="d-flex">
              <button
                class="btn static_remove_button btn-outline-secondary w-50"
                variant="secondary"
                onClick={remove}
              >
                Remove
              </button>
              <button
                class="btn static_wishlist_button btn-outline-primary w-50"
                variant="secondary"
                disabled={buttonDisabled}
                onClick={wishlist}
              >
                {" "}
                Move To Wishlist
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveCartModule;
